import React, { FC } from 'react';

import { TRANSACTION_TYPE } from '../../types';

interface ILoadIconProps {
  type: TRANSACTION_TYPE;
  color?: string;
}

const LoadIcon: FC<ILoadIconProps> = ({ type, color = '#444444' }) => {
  switch (type) {
    case 'CREDIT':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M15 10.1215C16.5344 10.8082 17.5 11.806 17.5 12.9167C17.5 14.9877 14.1421 16.6667 10 16.6667C5.85786 16.6667 2.5 14.9877 2.5 12.9167C2.5 11.806 3.46563 10.8082 5 10.1215"
            stroke="#444444"
          />
          <path
            d="M5.83334 8.33331L10 12.5L14.1667 8.33331"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 12.5L10 3.33331"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'CREDIT_REPAYMENT':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M14.1667 6.66669L9.99999 2.50002L5.83332 6.66669"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 2.5L10 12.5"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <ellipse cx="10" cy="12.9167" rx="7.5" ry="3.75" stroke="#444444" />
        </svg>
      );
    case 'ISSUE':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M9.99999 18.3334C14.6024 18.3334 18.3333 14.6024 18.3333 10C18.3333 5.39765 14.6024 1.66669 9.99999 1.66669C5.39762 1.66669 1.66666 5.39765 1.66666 10C1.66666 14.6024 5.39762 18.3334 9.99999 18.3334Z"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.33334 5.83331H11.6667C12.5872 5.83331 13.3333 6.5795 13.3333 7.49998V7.49998C13.3333 8.42046 12.5872 9.16665 11.6667 9.16665H8.33334"
            stroke="#444444"
          />
          <path
            d="M8.33334 5.83331C8.33334 8.61109 8.33334 14.1666 8.33334 14.1666"
            stroke="#444444"
            strokeLinecap="round"
          />
          <path
            d="M5.83334 11.6667H11.6667"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'REDEEM':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M9.99999 18.3334C14.6024 18.3334 18.3333 14.6024 18.3333 10C18.3333 5.39765 14.6024 1.66669 9.99999 1.66669C5.39762 1.66669 1.66666 5.39765 1.66666 10C1.66666 14.6024 5.39762 18.3334 9.99999 18.3334Z"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.33334 5.83331H11.6667C12.5872 5.83331 13.3333 6.5795 13.3333 7.49998V7.49998C13.3333 8.42046 12.5872 9.16665 11.6667 9.16665H8.33334"
            stroke="#444444"
          />
          <path
            d="M8.33334 5.83331C8.33334 8.61109 8.33334 14.1666 8.33334 14.1666"
            stroke="#444444"
            strokeLinecap="round"
          />
          <path
            d="M5.83334 11.6667H11.6667"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'ISSUE_PAYMENT':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M9.99999 18.3334C14.6024 18.3334 18.3333 14.6024 18.3333 10C18.3333 5.39765 14.6024 1.66669 9.99999 1.66669C5.39762 1.66669 1.66666 5.39765 1.66666 10C1.66666 14.6024 5.39762 18.3334 9.99999 18.3334Z"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.33334 5.83331H11.6667C12.5872 5.83331 13.3333 6.5795 13.3333 7.49998V7.49998C13.3333 8.42046 12.5872 9.16665 11.6667 9.16665H8.33334"
            stroke="#444444"
          />
          <path
            d="M8.33334 5.83331C8.33334 8.61109 8.33334 14.1666 8.33334 14.1666"
            stroke="#444444"
            strokeLinecap="round"
          />
          <path
            d="M5.83334 11.6667H11.6667"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'PURCHASE':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.83334 8.33334L10 12.5L14.1667 8.33334"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 12.5V2.5"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'SALE':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.1667 6.66667L10 2.5L5.83334 6.66667"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 2.5V12.5"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'EXCHANGE':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="load-icon"
        >
          <path
            d="M13.3333 2.5L16.6666 5.83333L13.3333 9.16667"
            stroke={color || '#444444'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 5.83334H16.6667"
            stroke={color || '#444444'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66659 17.5L3.33325 14.1667L6.66659 10.8333"
            stroke={color || '#444444'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.9999 14.1667H3.33325"
            stroke={color || '#444444'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return <></>;
  }
};

export default LoadIcon;
